import { createStore } from 'vuex';
import userModule from "./modules/user"
import categoryModule from "./modules/category"
import subCategoryModule from "./modules/sub-category"
import catalogModuleName from "./modules/catalog"
import employeeModuleName from "./modules/employee"
import pointsModuleName from "./modules/points"
import teamModuleName from "./modules/team"
import shiftModuleName from "./modules/shift"
import redeemModuleName from "./modules/redeem"
import activityLogModuleName from "./modules/activity-log"
import actions from './actions';
import mutations from './mutations';
import { CATEGORY_MODULE_NAME, SUB_CATEGORY_MODULE_NAME, USER_MODULE_NAME, CATALOG_MODULE_NAME, EMPLOYEE_MODULE_NAME, POINTS_MODULE_NAME, TEAMS_MODULE_NAME, SHIFT_MODULE_NAME, REDEEM_MODULE_NAME, ACTIVITY_LOG_MODULE_NAME } from './module-names';

export default new createStore({
    state: {
        layout: 'app',
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
        dark_mode: 'light',
        locale: null,
        menu_style: 'vertical',
        layout_style: 'full',
        auth_data:{
            username: '',
            password: '',
            temp_password: ''
        },
        auth:{
            is_authenticated: false,
            user_type: "",
            user:{}
        },
        isLoading: false,
        countryList: [
            { code: 'zh', name: 'Chinese' },
            { code: 'en', name: 'English' }
        ]
    },
    mutations: mutations,
    
    getters: {
        layout(state) {
            return state.layout;
        },
        isLoading(state) {
            return state.isLoading;
        },
        isAuthenticated(state) {
            const idTokenValue = localStorage.getItem("IdToken");
            if (idTokenValue !== null)  // The key "IdToken" exists in the localStorage
                return state.auth.is_authenticated || localStorage.getItem("IdToken").length > 5;
            
            return false;
        },
        getAuthData(state){
            let authData = state.auth_data
            if(authData.username || authData.password)
                return state.auth_data

            authData = localStorage.getItem("auth_data")
            if(authData !== null){
                authData  = JSON.parse(authData)
                if(authData.username && authData.password)
                    return authData
            }

            return state.auth_data
        }
    },
    actions: 
        actions
    ,
    modules: {
        [USER_MODULE_NAME]: userModule,
        [CATEGORY_MODULE_NAME]: categoryModule,
        [SUB_CATEGORY_MODULE_NAME]: subCategoryModule,
        [CATALOG_MODULE_NAME]: catalogModuleName,
        [EMPLOYEE_MODULE_NAME]: employeeModuleName,
        [POINTS_MODULE_NAME]: pointsModuleName,
        [TEAMS_MODULE_NAME]: teamModuleName,
        [SHIFT_MODULE_NAME]: shiftModuleName,
        [REDEEM_MODULE_NAME]: redeemModuleName,
        [ACTIVITY_LOG_MODULE_NAME]: activityLogModuleName
    },
});
